import axios from 'axios';
import {asBlob} from 'html-docx-js-typescript';

import {MessageBox} from 'element-ui';
class ReportWorker {

    // 动态加载html2pdf.js
    async loadHtml2Pdf() {
        return new Promise((resolve, reject) => {
            if (typeof window === 'undefined') {
                reject(new Error('只能在浏览器环境中运行'));
                return;
            }

            // 检查是否已加载
            if (window.html2pdf) {
                resolve(window.html2pdf);
                return;
            }

            const script = document.createElement('script');
            script.src = '/html2pdf.bundle.min.js'
            script.onload = () => {
                resolve(window.html2pdf);
            };
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }


    async fetchAIReport(summary) {
        const url = 'https://dify.idechat.com/v1/chat-messages';

        // 请求头
        const headers = {
            'Authorization': 'Bearer app-APZybxEUUBjaupZmP9xi5kgy',
            'Content-Type': 'application/json'
        };

        // 请求体
        const body = JSON.stringify({
            inputs: {},
            query: summary,
            response_mode: "blocking",
            user: "abc-123"
        });

        try {
            // 发起请求
            const response = await fetch(url, {
                method: 'POST',
                headers: headers,
                body: body
            });

            const data = await response.json();
            console.log(data.answer,'我是原始回复的内容')
            return data.answer; // 返回答案

        } catch (error) {
            console.error('接口请求失败:', error);
            MessageBox.alert('接口请求失败，请重试', '错误提示', {
                confirmButtonText: '确定',
                type: 'error'
            });

            throw new Error('接口请求失败');
        }
    }


    // 把 HTML 做个统一处理，替换掉 <canvas>
    async prepareExportContent(htmlContent, userName, options = {}) {
        const schoolName = sessionStorage.getItem("zhmc") || "未知学校";
        const today = new Date().toISOString().split("T")[0];

        // 替换为本地
        let processedHtml = htmlContent.replace('<script src="https://cdn.jsdelivr.net/npm/chart.js"></script>', '<script src="/chart.js"></script>');
        let personalizedContent = processedHtml
            .replace('<h1>校长数字画像报告</h1>', `<h1>${userName}的校长数字画像报告</h1>`)
            .replace(/<p[^>]*>.*?评估对象：.*?<\/p>/i, `<div style="margin-bottom: 20px;">
        <p><strong>评估对象：</strong>${userName} | ${schoolName}</p>
        <p><strong>报告日期：</strong>${today}</p>
      </div>`);

        const {
            timeout = 15000, checkInterval = 100
        } = options;


        // 创建 iframe 渲染 HTML
        const iframe = await this.createHiddenIframe(personalizedContent);
        await this.waitForCanvasRendering(iframe, timeout, checkInterval);

        // ✅ 把 canvas 转换成 img
        const processedHtmlFinal = await this.convertCanvasToImages(iframe, personalizedContent);

        // 清理 iframe
        document.body.removeChild(iframe);

        return processedHtmlFinal;
    }

    async generateWordFile(htmlContent, userName, options = {}) {
        try {
            // 统一走 prepareExportContent
            const processedHtml = await this.prepareExportContent(htmlContent, userName, options);

            // 用 html-docx-js 导出 Word
            return await this.generateWordDocumentWithHtmlDocx(processedHtml);
        } catch (error) {
            console.error('HTML转Word转换失败:', error);
            throw error;
        }
    }

    async generatePdfFile(htmlContent, userName, options = {}) {
        try {
            const processedHtml = await this.prepareExportContent(htmlContent, userName, options);

            const iframe = await this.createHiddenIframe(processedHtml);

            await new Promise(resolve => setTimeout(resolve, 1000));

            const pdfBlob = await this.generatePdfWithHtml2Pdf(iframe);

            // 清理 iframe
            document.body.removeChild(iframe);

            return pdfBlob;
        } catch (error) {
            console.error('HTML转PDF转换失败:', error);
            throw error;
        }
    }

    async generatePdfWithHtml2Pdf(iframe) {
        const html2pdf = await this.loadHtml2Pdf();

        return new Promise((resolve, reject) => {
            try {
                const doc = iframe.contentDocument || iframe.contentWindow.document;
                const element = doc.documentElement;

                element.style.visibility = 'visible';
                element.style.display = 'block';

                // 设置合适的样式确保PDF完整
                const style = doc.createElement('style');
                style.textContent = `
          body {
            margin: 0;
            padding: 20px;
            font-family: Arial, sans-serif;
            line-height: 1.6;
          }
          * {
            box-sizing: border-box;
          }
          img {
            max-width: 100% !important;
            height: auto !important;
          }
          canvas {
            display: block;
            margin: 10px auto;
          }
          .page-break {
            page-break-before: always;
          }
        `;
                doc.head.appendChild(style);

                // 等待样式应用
                setTimeout(async () => {
                    try {
                        // 使用html2pdf.js生成PDF
                        const opt = {
                            margin: [10, 10, 10, 10], filename: `${sessionStorage.getItem("xm")}画像报告.pdf`, image: {
                                type: 'jpeg', quality: 0.98
                            }, html2canvas: {
                                scale: 2, useCORS: true, logging: false, backgroundColor: '#ffffff'
                            }, jsPDF: {
                                unit: 'mm', format: 'a4', orientation: 'portrait'
                            }, pagebreak: {
                                mode: ['avoid-all', 'css', 'legacy'], avoid: ['img', '.chart-container']
                            }
                        };

                        // 从iframe中获取内容
                        const content = doc.documentElement;

                        // 生成PDF
                        const pdfGenerator = html2pdf()
                            .set(opt)
                            .from(content)
                            .toPdf()
                            .get('pdf');

                        // 等待PDF生成完成
                        pdfGenerator.then(pdf => {
                            const pdfBlob = pdf.output('blob');
                            resolve(pdfBlob);
                        }).catch(reject);

                    } catch (error) {
                        reject(error);
                    }
                }, 1000); // 给足够的时间让样式生效
            } catch (error) {
                reject(error);
            }
        });
    }

    createHiddenIframe(htmlContent) {
        return new Promise((resolve, reject) => {
            const iframe = document.createElement("iframe");
            iframe.style.position = "absolute";
            iframe.style.left = "-9999px";
            iframe.style.top = "-9999px";
            iframe.style.width = "800px"; // 调整为A4纸的宽度比例
            iframe.style.height = "1200px";
            iframe.style.border = "none";
            iframe.style.visibility = "visible";

            // 设置基本的HTML结构
            const fullHtml = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <style>
            body {
              margin: 0;
              padding: 20px;
              font-family: Arial, sans-serif;
              line-height: 1.6;
              background: white;
            }
            * {
              box-sizing: border-box;
            }
            img {
              max-width: 100% !important;
              height: auto !important;
            }
            canvas {
              display: block;
              margin: 15px auto;
              max-width: 100%;
            }
            .page-break {
              page-break-before: always;
            }
            @media print {
              body {
                padding: 15px;
              }
            }
          </style>
        </head>
        <body>
          ${htmlContent}
        </body>
        </html>
      `;
            console.log(fullHtml,'转换')
            iframe.srcdoc = fullHtml;

            iframe.onload = () => {
                console.log("iframe加载完成，等待内容渲染");
                // 给更多时间确保所有资源加载完成
                setTimeout(() => resolve(iframe), 6000);
            };

            iframe.onerror = reject;
            document.body.appendChild(iframe);
        });
    }

    waitForCanvasRendering(iframe, timeout = 20000, checkInterval = 500) {
        return new Promise((resolve, reject) => {
            const startTime = Date.now();
            let retryCount = 0;
            const maxRetries = 10;

            const checkCanvases = () => {
                try {
                    const doc = iframe.contentDocument || iframe.contentWindow.document;
                    const canvases = doc.querySelectorAll('canvas');

                    if (canvases.length === 0) {
                        console.log('没有找到Canvas元素，继续处理');
                        resolve();
                        return;
                    }

                    let allRendered = true;
                    let blankCanvasCount = 0;

                    for (const canvas of canvases) {
                        if (this.isCanvasBlank(canvas)) {
                            allRendered = false;
                            blankCanvasCount++;
                        }
                    }

                    if (allRendered) {
                        console.log('所有Canvas已渲染完成');
                        resolve();
                    } else if (Date.now() - startTime > timeout) {
                        console.warn(`画布渲染超时，继续处理。空白Canvas数量: ${blankCanvasCount}/${canvases.length}`);
                        resolve();
                    } else if (retryCount >= maxRetries) {
                        console.warn(`达到最大重试次数，继续处理。空白Canvas数量: ${blankCanvasCount}/${canvases.length}`);
                        resolve();
                    } else {
                        retryCount++;
                        console.log(`Canvas渲染中，重试 ${retryCount}/${maxRetries}，空白Canvas数量: ${blankCanvasCount}/${canvases.length}`);
                        setTimeout(checkCanvases, checkInterval);
                    }
                } catch (error) {
                    console.error('检查Canvas渲染状态时出错:', error);
                    reject(error);
                }
            };

            setTimeout(checkCanvases, checkInterval);
        });
    }

    isCanvasBlank(canvas) {
        try {
            // 添加willReadFrequently属性
            const ctx = canvas.getContext('2d', {willReadFrequently: true});
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;

            // 检查是否所有像素都是透明或白色
            for (let i = 0; i < data.length; i += 4) {
                const r = data[i];
                const g = data[i + 1];
                const b = data[i + 2];
                const a = data[i + 3];

                // 如果有非透明且非白色的像素，则认为不是空白
                if (a > 0 && (r !== 255 || g !== 255 || b !== 255)) {
                    return false;
                }
            }
            return true;
        } catch (error) {
            // 如果无法读取画布内容（可能是跨域），假设已渲染
            console.warn('无法检查画布内容，假设已渲染:', error);
            return false;
        }
    }

    async convertCanvasToImages(iframe, originalHtml) {
        const doc = iframe.contentDocument || iframe.contentWindow.document;
        const canvases = doc.querySelectorAll('canvas');

        // 创建一个映射来存储canvas id和对应的图片数据
        const canvasImageMap = new Map();
        let canvasCounter = 0;

        for (const canvas of canvases) {
            try {
                // 将画布转换为图片
                const dataURL = canvas.toDataURL('image/png');
                const canvasId = canvas.id || `auto-generated-canvas-${canvasCounter++}`;

                // 构建img标签，保持原有的属性
                const width = canvas.getAttribute('width') || canvas.style.width || '500';
                const height = canvas.getAttribute('height') || canvas.style.height || '300';

                const imgTag = `<img src="${dataURL}" width="${width}" height="${height}" style="margin: 20px auto; display: block; max-width: 90%;" alt="Chart: ${canvasId}" />`;

                // 如果canvas没有ID，我们需要用其他方式标识它
                if (canvas.id) {
                    canvasImageMap.set(canvasId, imgTag);
                } else {
                    // 为没有ID的canvas创建一个唯一标识符
                    const canvasHTML = canvas.outerHTML;
                    canvasImageMap.set(canvasHTML, imgTag);
                }
            } catch (error) {
                console.warn('转换画布失败:', error, canvas.id || '无ID');
            }
        }

        // 使用原始HTML作为基础，替换canvas标签
        let processedHtml = originalHtml;

        // 先替换有ID的canvas
        for (const [canvasId, imgTag] of canvasImageMap) {
            if (!canvasId.startsWith('<canvas')) {
                // 使用正则表达式精确匹配并替换对应id的canvas标签
                const canvasRegex = new RegExp(`<canvas[^>]*id=["']${canvasId}["'][^>]*></canvas>`, 'gi');
                processedHtml = processedHtml.replace(canvasRegex, imgTag);
            }
        }

        // 再替换没有ID的canvas
        for (const [canvasHTML, imgTag] of canvasImageMap) {
            if (canvasHTML.startsWith('<canvas')) {
                // 直接替换整个canvas HTML
                processedHtml = processedHtml.replace(canvasHTML, imgTag);
            }
        }
        console.log(processedHtml,'转换')
        return processedHtml;
    }

    async generateWordDocumentWithHtmlDocx(htmlContent) {
        try {
            // 使用html-docx-js转换HTML为Word文档
            const converted = asBlob(htmlContent);

            // 如果返回的是Promise，等待结果
            if (converted instanceof Promise) {
                return await converted;
            }

            return converted;
        } catch (error) {
            console.error('使用html-docx-js生成Word文档失败:', error);
            throw error;
        }
    }


}

export default new ReportWorker();
